import { isPlatformServer } from "@angular/common";
import { HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import {
    inject,
    PLATFORM_ID,
} from "@angular/core";
import { of } from "rxjs";
import {
    catchError,
    timeout,
} from "rxjs/operators";

const SSR_REQUEST_TIMEOUT_MS = 5000;

/**
 * Prevents SSR prerender from hanging when backend API calls never respond.
 *
 * Root cause: provideSeedCategories() registers updateCategories$ ngrx effect that fires on
 * loadUserSuccess/logoutUserSuccess, triggering an HTTP call to gameCategoryList. If the backend
 * is slow or unreachable during build, this request hangs and Angular SSR never stabilizes.
 * SeoTextDirective.ngOnInit() also makes an uncovered HTTP call that can hang.
 *
 * This interceptor times out all server-side HTTP requests after SSR_REQUEST_TIMEOUT_MS,
 * returning an empty 200 response so Angular can stabilize and complete the prerender.
 * On client, requests run without a timeout.
 */
export const ssrHttpTimeoutInterceptor: HttpInterceptorFn = (req, next) => {
    if (!isPlatformServer(inject(PLATFORM_ID))) {
        return next(req);
    }

    return next(req).pipe(
        timeout(SSR_REQUEST_TIMEOUT_MS),
        catchError(() => of(new HttpResponse({ status: 200, body: null }))),
    );
};
